import Nav from '../../../Global/Nav.vue'
import * as echarts from 'echarts'
const today = new Date()
const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)
export default {
  name: 'Websites',
  components: {
    Nav
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      websiteLoading: true,
      domainLoading: true,
      dnspodLoading: true,
      sslLoading: true,
      deployLoading: true,
      statistics: {
        website: {
          total: '-',
          on: '-',
          off: '-'
        },
        domain: {
          total: '-',
          auto_renew: '-',
          expired_in_month: '-'
        },
        dnspod: {
          total: '-',
          normal: '-',
          error: '-'
        },
        ssl: {
          total: '-',
          recent_updated: '-',
          expired_in_month: '-'
        },
        deploy: {
          total: '-',
          success: '-',
          failed: '-'
        }
      },
      selectedYear: new Date().getFullYear().toString(),
      chart1Loading: true,
      chart2Date: {
        year: yesterday.getFullYear(),
        month: yesterday.getMonth() + 1,
        day: yesterday.getDate()
      },
      chart2Loading: true
    }
  },
  async mounted() {
    await Promise.all([
      this.getWebsiteStatistics(),
      this.getDomainStatistics(),
      this.getDnspodStatistics(),
      this.getSslStatistics(),
      this.getDeployStatistics()
    ]);
    this.drawChart1();
    this.drawChart2();
  },
  methods: {
    getWebsiteStatistics() {
      this.websiteLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=website`).then((response) => {
        this.websiteLoading = false;
        if (response.data.code === 200) {
          this.statistics.website = response.data.data;
        }
      });
    },
    getDomainStatistics() {
      this.domainLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=domain`).then((response) => {
        this.domainLoading = false;
        if (response.data.code === 200) {
          this.statistics.domain = response.data.data;
        }
      });
    },
    getDnspodStatistics() {
      this.dnspodLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=dnspod`).then((response) => {
        this.dnspodLoading = false;
        if (response.data.code === 200) {
          this.statistics.dnspod = response.data.data;
        }
      });
    },
    getSslStatistics() {
      this.sslLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=ssl`).then((response) => {
        this.sslLoading = false;
        if (response.data.code === 200) {
          this.statistics.ssl = response.data.data;
        }
      });
    },
    getDeployStatistics() {
      this.deployLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=deploy`).then((response) => {
        this.deployLoading = false;
        if (response.data.code === 200) {
          this.statistics.deploy = response.data.data;
        }
      });
    },
    async drawChart1() {
      const dom = document.getElementById('chart1')
      if (!this.chart1) {
        this.chart1 = this.$echarts.init(dom)
      }
      const year = this.selectedYear
      const formatBytes = this.formatBytes;
      await this.$axios.get(`/websites/backend/statistics?type=cdn_traffic&year=${year}`).then((res) => {
        this.chart1Loading = false
        if (res.data.code === 200) {
          const values = res.data.data.map(v => v[1])
          let option1 = {
            title: {
              text: '年度流量一览',
              left: 'left',
              top: 0
            },
            tooltip: {
              position: 'top',
              formatter: function (params) {
                const date = params.data[0];
                const value = params.data[1] || 0;
                const d = new Date(date);

                return [
                  `${d.getMonth() + 1}月${d.getDate()}日`,
                  `${params.marker}${formatBytes(value)}`
                ].join('<br/>');
              }
            },
            visualMap: {
              min: 0,
              max: Math.max(...values),
              calculable: true,
              orient: 'horizontal',
              left: 'right',
              top: 0,
              itemHeight: 600,
              inRange: {
                color: [
                  '#eef2fb',
                  '#d8e1f5',
                  '#c0cdea',
                  '#9fb2de',
                  '#7c97d3',
                  '#5a7ec7',
                  '#3f66b9'
                ]
              }
            },
            calendar: [
              {
                top: 80,
                range: year,
                cellSize: ['auto', 20]
              }
            ],
            series: [
              {
                type: 'heatmap',
                coordinateSystem: 'calendar',
                calendarIndex: 0,
                data: res.data.data
              }
            ]
          }
          this.chart1.setOption(option1)
          this.bindChartClick()
        }
      });
    },
    bindChartClick() {
      this.chart1.off('click')
      this.chart1.on('click', (params) => {
        const date = params.value[0]
        const value = params.value[1]
        const d = new Date(date)
        const payload = {
          type: 'day',
          year: d.getFullYear(),
          month: d.getMonth() + 1,
          day: d.getDate(),
          value: value
        }
        this.chart2Date = {
          year: payload.year,
          month: payload.month,
          day: payload.day
        };
        setTimeout(() => {
          this.drawChart2()
        }, 0);
      })
    },
    async drawChart2() {
      const dom = document.getElementById('chart2')
      if (!this.chart2) {
        this.chart2 = this.$echarts.init(dom)
      }
      let year = this.chart2Date.year;
      let month = this.chart2Date.month;
      let day = this.chart2Date.day;
      const formatBytes = this.formatBytes;
      await this.$axios.get(`/websites/backend/statistics/detail?type=cdn_traffic&year=${year}&month=${month}&day=${day}`).then((res) => {
        this.chart2Loading = false
        if (res.data.code === 200) {
          const data = res.data.data;
          const valueData = (data.valueData || []).map(item => Number(item) || 0);
          let option2 = {
            title: {
              text: year + '年' + month + '月' + day + '日 分时流量',
              left: 10,
              top: 20
            },
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: false
                },
                saveAsImage: {
                  pixelRatio: 2
                }
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              formatter: function (params) {
                if (!params || !params.length) return '';

                const item = params[0];
                const time = item.axisValue;
                const value = Number(item.data) || 0;

                return [
                  `${time}`,
                  `${item.marker}流量: ${formatBytes(value)} (${echarts.format.addCommas(value)} B)`
                ].join('<br/>');
              }
            },
            grid: {
              bottom: 90
            },
            dataZoom: [
              {
                type: 'inside'
              },
              {
                type: 'slider'
              }
            ],
            xAxis: {
              type: 'category',
              data: data.categoryData,
              silent: false,
              splitLine: {
                show: false
              },
              splitArea: {
                show: false
              }
            },
            yAxis: {
              type: 'value',
              splitArea: {
                show: false
              },
              axisLabel: {
                formatter: function (value) {
                  return formatBytes(value);
                }
              }
            },
            series: [
              {
                name: '流量',
                type: 'bar',
                data: valueData,
                large: true
              }
            ]
          };

          this.chart2.setOption(option2)
        }
      });
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === null || bytes === undefined || bytes === '') return '-';
      const num = Number(bytes);
      if (isNaN(num)) return '-';
      if (num === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
      const i = Math.floor(Math.log(Math.abs(num)) / Math.log(k));
      const value = num / Math.pow(k, i);
      return `${value.toFixed(decimals).replace(/\.?0+$/, '')} ${sizes[i]}`;
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Websites/Index/script.js